var site = site || {};
site.Navigation = (function () {

    const navbar = document.querySelector('.js-navbar');
    const navbarHeight = navbar.offsetHeight;
    const navbarToggler = document.querySelector('.js-navbar-toggler')
    const heroWidget = document.querySelector('.js-hero')
    
    const autoHideNav = () => {
        if(!heroWidget) {
            document.body.style.paddingTop = (navbarHeight + 62) + 'px';
        }
        if(navbar){
            let lastScrollTop = 0;
            window.addEventListener('scroll', function() {
                // Close any open subnavs
                const subNavs = document.querySelectorAll('.js-subnav')
                subNavs.forEach(subNav => {
                    const subNavToggle = new bootstrap.Dropdown(subNav.querySelector('.js-subnav-dropdown-toggle'))
                    subNavToggle.hide()
                    subNav.querySelector('.js-subnav-dropdown-toggle').blur();
                });

                let scrollTop = window.scrollY;
                if(heroWidget) {
                    if(scrollTop < lastScrollTop) {
                        if(scrollTop == 0) {
                            navbar.classList.add('text-invert')
                            navbar.classList.remove('scrolled-up', 'scrolled-down')
                        } else {
                            navbar.classList.remove('scrolled-down');
                            navbar.classList.add('scrolled-up');
                        }
                    }
                    else {
                        navbar.classList.remove('scrolled-up', 'text-invert');
                        navbar.classList.add('scrolled-down');
                    }
                }
                else {
                    navbar.classList.remove('text-invert')
                    navbar.classList.add('scrolled-up')
                    if(scrollTop < lastScrollTop) {
                        if(scrollTop == 0) {
                            navbar.classList.add('scrolled-up')
                        } 
                        else {
                            navbar.classList.add('scrolled-up');
                        }
                    }
                    else {
                        navbar.classList.remove('scrolled-up');
                        navbar.classList.add('scrolled-down');
                    }
                }
                lastScrollTop = scrollTop;
            }); 
            if(!heroWidget) {
                navbar.classList.add('scrolled-up');
                navbar.classList.remove('text-invert');
            }
        }
    } 


    const handleNavToggle = () => {
        navbarToggler.addEventListener('click', () => {
            navbar.classList.toggle('navbar-open');
            navbar.classList.toggle('text-invert');
            document.body.classList.toggle('overflow-hidden');
        })
    }

    const subNavToggle = () => {
        const subNavs = document.querySelectorAll('.js-subnav');
        subNavs.forEach(subNav => {
            subNav.addEventListener('show.bs.dropdown', () => {
                let toggleIcons = subNav.querySelectorAll('.js-subnav-toggle-icon');
                toggleIcons.forEach(icon => {
                    icon.classList.toggle('d-none')
                })
            })
            subNav.addEventListener('hide.bs.dropdown', () => {
                let toggleIcons = subNav.querySelectorAll('.js-subnav-toggle-icon');
                toggleIcons.forEach(icon => {
                    icon.classList.toggle('d-none')
                })
            })
        })
    }

    const mobileDestkopTransition = (mediaQueries) => {
        const subNavs = document.querySelectorAll('.js-subnav');
        if (mediaQueries.xl.matches) {
            const mobileNavToggle = document.querySelector('.js-navbar-toggler')
            const mobileNavOpened = mobileNavToggle.getAttribute('aria-expanded');
            if (mobileNavOpened == "true") {
                mobileNavToggle.click();
            }
            subNavs.forEach(subNav => {
                const subNavToggle = new bootstrap.Dropdown(subNav.querySelector('.js-subnav-dropdown-toggle'))
                subNavToggle.hide();
            })
        }
    }

    // Return
    return {
        autoHideNav : autoHideNav,
        handleNavToggle : handleNavToggle,
        subNavToggle : subNavToggle,
        mobileDestkopTransition : mobileDestkopTransition
    };
}());